export const PREFIX = "_RESET_";
export default function defaultState(namespace, initialState) {
  const getInitialState = () => ({ ...initialState });
  return {
    state: getInitialState(),
    mutations: {
      [`${PREFIX}${namespace}`](state) {
        Object.assign(state, getInitialState());
      },
    },
  };
}
